// extracted by mini-css-extract-plugin
module.exports = {"policyLinkContainer":"PoliciesTable_policyLinkContainer__2QYGM","currencyContainer":"PoliciesTable_currencyContainer__299z8"};